import { PayloadAction, combineReducers, createSlice } from '@reduxjs/toolkit'

import CrackDetectionReducer from './crackDetection'
import PolylineReducer from './polyline'

export enum PolylineToolMode {
  Draw,
  CrackDetection,
}

export interface PolylineCoreState {
  /**
   * Current mode of the polyline tool.
   */
  mode: PolylineToolMode

  /**
   * Flag to determine if the polyline tool is currently saving.
   */
  isSaving: boolean
}

const initialState: PolylineCoreState = {
  mode: PolylineToolMode.Draw,
  isSaving: false,
}

export const slice = createSlice({
  name: 'editor/tools/polyline/core',
  initialState,
  reducers: {
    // ## Modes
    setMode(state, action: PayloadAction<PolylineToolMode>) {
      state.mode = action.payload
    },
    resetMode: (state) => {
      state.mode = initialState.mode
    },

    // ## Saving
    setSaving(state, action: PayloadAction<boolean>) {
      state.isSaving = action.payload
    },

    // Reset
    reset: () => initialState,
  },
})

export const {
  // Modes
  setMode,
  resetMode,

  // Saving
  setSaving,

  // Reset
  reset,
} = slice.actions

const rootReducer = combineReducers({
  core: slice.reducer,
  polyline: PolylineReducer,
  crackDetection: CrackDetectionReducer,
})

export default rootReducer

export type PolylineToolState = ReturnType<typeof rootReducer>
